import tracking from './dynamic-youtube-gtm-tracking'

export default function setModalVideo({ videoHost, videoId, videoUrl = null }) {
    const url = videoUrl || getVideoUrl(videoHost, videoId);
    const cookieScriptEnabled = window.cookieScriptEnabled;

    window.hasAcceptedYoutubeCookies = !!window.hasAcceptedYoutubeCookies || cookieScriptEnabled && CookieScript.instance.currentState().categories.includes('targeting');
    const self = {};
    self.modal = document.querySelector(`.modal`);
    self.modalClose = document.querySelector(`.modal .modal__close`);

    function appendModal(modalContent) {
        self.modal.appendChild(modalContent);
        if (!self.modal.classList.contains('active')) {
            self.modal.classList.add("active");
            tracking.digestPotentialVideos(self.modal.querySelectorAll('iframe'));
        }
        self.modal.dataset.fromTemplate = "false";
    }

    function createModal() {
        const modalOverlay = document.querySelector(`.modal__video-overlay`) || document.createElement("div");
        if (!modalOverlay.classList.contains(`modal__video-overlay`))
            modalOverlay.classList.add(`modal__video-overlay`);

        const iframewrapper = document.querySelector(`.modal__video-wrapper`) || document.createElement("div");
        if (!iframewrapper.classList.contains(`modal__video-wrapper`))
            iframewrapper.classList.add(`modal__video-wrapper`);

        let videoElement;
        if (videoHost === "youtube" || videoHost === "vimeo") {
            videoElement = document.createElement("iframe");
            videoElement.setAttribute("src", url);
            videoElement.setAttribute("frameborder", "0");
            videoElement.setAttribute("allow", "autoplay; fullscreen");
            videoElement.setAttribute("allowfullscreen", "");
        } else {
            videoElement = document.createElement("video");
            videoElement.setAttribute("controlsList", "nodownload");
            videoElement.setAttribute("src", url);
            videoElement.setAttribute("autoplay", "");
            videoElement.setAttribute("controls", "");
        }
        videoElement.classList.add("modal__video");
        if (videoElement.tagName === "VIDEO") {
            videoElement.addEventListener("contextmenu", e => e.preventDefault());
        }

        iframewrapper.appendChild(videoElement);
        modalOverlay.appendChild(iframewrapper);
        self.modal.addEventListener("click", closeModal);
        return modalOverlay;
    }

    function closeModal(e, closeElement = null, toggleActive = true) {
        e.stopPropagation();
        if (e.target === self.modal || (e.target === self.modalClose || e.target === closeElement)) {
            let videoPlayer = self.modal.querySelector(`.modal__video-overlay`);
            if (videoPlayer) videoPlayer.remove();
            if (toggleActive) {
                self.modal.classList.remove("active");
            }
        }
    }

    function getVideoUrl(videoHost, videoId) {
        if (videoHost === "youtube") {
            return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
        }
        else if (videoHost === "vimeo") {
            return `https://player.vimeo.com/video/${videoId}?autoplay=1&autopause=0&dnt=1`;
        }
        else if (videoHost === "qbank" && videoId.startsWith('http')) {
            return `${videoId}`;
        }
        else if (videoHost === 'qbank') {
            return `${document.location.origin}${videoId}`;
        }
    }

    function unescape(str) {
        let element = document.createElement("textarea");
        element.innerHTML = str;
        return element.value;
    }

    function createCookieScriptModal() {
        const closeButton = self.modal.querySelector(`.modal .modal__close`);
        closeButton.style.display = "none";
        const template = document.createElement('template');
        const title = window.youtubeCookieConsentTitle || 'Videon kräver godkännande av cookies för tredjepart';
        let preamble = window.youtubeCookieConsentText ? unescape(window.youtubeCookieConsentText) : "<p>Videon kräver godkännande av cookies för tredjepart, youtube.com. Genom att visa videon godkänner du att cookies sparas från youtube.com enligt <a href='https://www.youtube.com/t/terms'>deras villkor</a>.</p>";

        template.innerHTML = `
        <div class="cookie-information">
            <div class="cookie-information__inner"></div>
            <button class="cookie-information__close"><span class="sr-only">Stäng</span></button>
            <div class="cookie-information__content">
                <h2 class="cookie-information__heading">${title}</h2>
                <div class="cookie-information__preamble">
                    ${preamble}
                </div>
                <div class="cookie-information__buttons">
                    <button class="cookie-information__button button-new button-new--primary">Visa video</button>
                    <button class="cookie-information__button cookie-information__button--secondary button-new button-new--secondary"><span>Avvisa</span></button>
                </div>
            </div>
        </div>
        `;
        const modal = template.content.firstElementChild;
        modal.querySelector("button.cookie-information__button").addEventListener("click", (e) => {
            e.stopPropagation();
            modal.remove();
            closeModal(e, false)
            appendModal(createModal());
            closeButton.style.display = null;
            window.hasAcceptedYoutubeCookies = true;
        });
        [...modal.querySelectorAll("button.cookie-information__close, button.cookie-information__button--secondary")].forEach(x => x.addEventListener("click", (e) => {
            e.stopPropagation();
            closeModal(e, e.target)

            closeButton.style.display = null;
        }));
        return modal;

    }

    const showCookieModal = url.includes("youtube") && cookieScriptEnabled && !CookieScript.instance.currentState().categories.includes('targeting');

    let modalContent;
    if (cookieScriptEnabled && !window.hasAcceptedYoutubeCookies && showCookieModal) {
        const cookieScriptModal = createCookieScriptModal();
        const modalOverlay = document.createElement("div");
        modalOverlay.classList.add(`modal__video-overlay`);

        modalOverlay.appendChild(cookieScriptModal);
        modalContent = modalOverlay;
    } else {
        modalContent = createModal();
    }

    appendModal(modalContent);
}

function toggleModal() {
    const modal = document.querySelector(`.modal`);
    if (modal) {
        modal.classList.toggle("active");
    }
}

const closeModal = (e) => {
    const modal = document.querySelector(`.modal`);
    if (modal) {
        modal.classList.remove("active");
    }
}

export const setModalFromTemplateElement = (templateId) => {
    const modal = document.querySelector(`.modal`);
    modal.dataset.fromTemplate = "true";
    const existingModals = modal.querySelectorAll(".modal__content");
    existingModals.forEach(x => x.style.display = "none");
    const currentModal = document.querySelector(`.modal-${templateId}`);
    if (currentModal) {
        currentModal.style.display = null;
        toggleModal();
        return;
    }

    const template = document.getElementById(templateId);
    if (!template) {
        console.error("No template with id " + templateId + " found.")
        return;
    }

    //set template id
    const templateContent = template.firstElementChild;

    templateContent.classList.add("modal-" + templateId);
    modal.appendChild(templateContent);
    const closeButton = modal.querySelector(`.modal__close`).cloneNode(true);
    closeButton.addEventListener("click", (e) => {
        const modalContent = e.currentTarget.parentElement.parentElement;
        modalContent.style.display = "none";
        modal.removeAttribute("data-from-template");
        console.log('foo')
        closeModal();
    });
    modal.classList.add("active");
    templateContent.firstElementChild.prepend(closeButton);
}